<mat-toolbar class="toolbar">
    <div class="vw-5">
      <button class="mr-3" mat-icon-button [matTooltip]="'createcustomElement.goBack' | translate" matTooltipPosition="right" (click)='cancel()'>
        <mat-icon class="mat-icon">keyboard_backspace</mat-icon>
      </button>
    </div>
    <div class="vw-50 text-center">
      <mat-form-field class="example-form-field mt-3 mx-3" appearance="fill">
        <mat-label>{{'createcustomElement.name' | translate}}</mat-label>
        <input matInput type="text" [(ngModel)]="customElementName">
        <button *ngIf="customElementName" matSuffix mat-icon-button aria-label="Clear" (click)="customElementName=''">
          <mat-icon class="mat-icon">close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field class="simple-mat-form-field mt-3 mx-3">
        <mat-label>{{'createcustomElement.selectApp' | translate}}</mat-label>
        <mat-select [(ngModel)]="application" disableOptionCentering>
          <mat-option *ngFor="let application of applications" [value]="application">
            {{application}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>  
    <button mat-icon-button class="mx-1" [matTooltip]="'createcustomElement.deleteSelect' | translate" matTooltipPosition="right"
      [ngClass]="{'btn-disabled': !selectedPropPanels || selectedPropPanels.length === 0}" (click)="deleteSelectedElement()"
      [hidden]="!selectedPropPanels || selectedPropPanels.length === 0">
      <i class="fas fa-trash menu-icon"></i>
    </button>
    <div class="vw-35">
    </div>
    <div class="d-flex vw-5">
      <button mat-icon-button class="mr-3" color="primary" (click)="openSaveDialog()" [matTooltip]="'createcustomElement.saveTemplate' | translate" matTooltipPosition="right"
      [ngClass]="{'btn-disabled': (!customElementName || !application)}">
        <i class="fas fa-save menu-icon"></i>
      </button>
    </div>
  </mat-toolbar>
<div class="d-flex report-preview-container">
    <aside class="side-menu">
      <div class="side-menu__cursor">
        <ul class="side-menu__list">  
          <li (mousedown)="onSelectObjectMenu('section', 'draw');$event.preventDefault()">
            <button class="elements-button" mat-flat-button [color]="buttonColors['section']">
              <mat-icon class="elements-icon">extension</mat-icon>
            </button>
            <div class="flex-grow-1">
              <span>{{'createcustomElement.section' | translate}}</span>
            </div>
          </li>
  
          <li (mousedown)="onSelectObjectMenu('text', 'draw');$event.preventDefault()">
            <button class="elements-button" mat-flat-button [color]="buttonColors['text']">
              <mat-icon class="elements-icon">title</mat-icon>
            </button>
            <div class="flex-grow-1">
              <span>{{'createcustomElement.text' | translate}}</span>
            </div>
          </li>
  
          <li (mousedown)="onSelectObjectMenu('line', 'draw');$event.preventDefault()">
            <button class="elements-button" mat-flat-button [color]="buttonColors['line']">
              <mat-icon class="elements-icon">remove</mat-icon>
            </button>
            <div class="flex-grow-1">
              <span>{{'createcustomElement.line' | translate}}</span>
            </div>
          </li>
  
          <li (mousedown)="onSelectObjectMenu('image', 'draw');$event.preventDefault()">
            <button class="elements-button" mat-flat-button [color]="buttonColors['image']">
              <mat-icon class="elements-icon">image</mat-icon>
            </button>
            <div class="flex-grow-1">
              <span>{{'createcustomElement.image' | translate}}</span>
            </div>
          </li>
  
          <li (mousedown)="onSelectObjectMenu('rectangle', 'draw');$event.preventDefault()">
            <button class="elements-button" mat-flat-button [color]="buttonColors['rectangle']">
              <mat-icon class="elements-icon" md-48>crop_7_5</mat-icon>
            </button>
            <div class="flex-grow-1">
              <span>{{'createcustomElement.rectangle' | translate}}</span>
            </div>
          </li>
  
          <li (mousedown)="onSelectObjectMenu('table', 'draw');$event.preventDefault()">
            <button class="elements-button" mat-flat-button [color]="buttonColors['table']">
              <mat-icon class="elements-icon" md-48>grid_on</mat-icon>
            </button>
            <div class="flex-grow-1">
              <span>{{'createcustomElement.table' | translate}}</span>
            </div>
          </li>
          <li (mousedown)="onSelectObjectMenu('dropDownList', 'draw');$event.preventDefault()">
            <button class="elements-button" mat-flat-button [color]="buttonColors['dropDownList']">
              <mat-icon class="elements-icon" md-48>list_alt</mat-icon>
            </button>
            <div class="flex-grow-1">
              <span>{{'createcustomElement.dropdownList' | translate}}</span>
            </div>
          </li>
        </ul>
      </div>
    </aside>
    <div class="flex-grow-1">
      <div class="report-content" (click)="onClick($event)">
        <div class="report-preview" id="pageScroll" (scroll)="scrollEvent($event)">
          <app-report-page-container *ngIf="pageKey" class="report-page-outer" (mousedown)="onMouseDown($event)"  [pageKey]="pageKey">
          </app-report-page-container>
        </div>
      </div>
    </div>
  
    <div class="property-preview-button d-flex" *ngIf="!showMenu || showMenu === 'elements'" (click)="showMenu = 'properties'" [matTooltip]="'createcustomElement.elementsSettings' | translate" matTooltipPosition="left">
      <mat-icon class="mr-2">palette</mat-icon>
    </div>
    <aside [hidden]="showMenu !== 'properties'" class="property-preview">
      <app-property-preview #property (closePropertyPanel)="showMenu=''"></app-property-preview>
    </aside>
</div>
